/**
 * lp-creator-ad — in-view muted autoplay + play/mute controls (LP §3.22).
 */
(function () {
  'use strict';

  var REDUCE =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function syncPlayUi(root, playing) {
    var btn = root.querySelector('[data-lp-creator-ad-toggle-play]');
    if (!btn) return;
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    var pauseIcon = btn.querySelector('.lp-creator-ad__btn-icon--pause');
    var playIcon = btn.querySelector('.lp-creator-ad__btn-icon--play');
    if (pauseIcon) pauseIcon.hidden = !playing;
    if (playIcon) playIcon.hidden = playing;
  }

  function syncMuteUi(root, muted) {
    var btn = root.querySelector('[data-lp-creator-ad-toggle-mute]');
    if (!btn) return;
    btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    var mutedIcon = btn.querySelector('.lp-creator-ad__btn-icon--muted');
    var unmutedIcon = btn.querySelector('.lp-creator-ad__btn-icon--unmuted');
    if (mutedIcon) mutedIcon.hidden = !muted;
    if (unmutedIcon) unmutedIcon.hidden = muted;
  }

  function safePlay(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function initRoot(root) {
    if (root.getAttribute('data-lp-creator-ad-ready') === '1') return;
    root.setAttribute('data-lp-creator-ad-ready', '1');

    var video = root.querySelector('[data-lp-creator-ad-video]');
    if (!video) return;

    var frame = root.querySelector('.lp-creator-ad__frame');
    var wantAutoplay = root.getAttribute('data-lp-creator-ad-autoplay') !== 'false';
    var userPaused = false;
    var inView = false;

    function syncAspectFromVideo() {
      if (!frame || !video.videoWidth || !video.videoHeight) return;
      frame.style.setProperty(
        '--lp-ca-aspect',
        video.videoWidth + ' / ' + video.videoHeight
      );
    }
    if (video.readyState >= 1) syncAspectFromVideo();
    video.addEventListener('loadedmetadata', syncAspectFromVideo);

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    syncMuteUi(root, true);
    syncPlayUi(root, false);

    var playBtn = root.querySelector('[data-lp-creator-ad-toggle-play]');
    var muteBtn = root.querySelector('[data-lp-creator-ad-toggle-mute]');

    function tryPlay() {
      if (!inView || userPaused) return;
      safePlay(video);
    }

    function pauseVideo() {
      video.pause();
      syncPlayUi(root, false);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          safePlay(video);
          syncPlayUi(root, true);
        } else {
          userPaused = true;
          pauseVideo();
        }
      });
    }

    function setMuted(muted) {
      video.muted = muted;
      video.defaultMuted = muted;
      if (muted) {
        video.setAttribute('muted', '');
      } else {
        video.removeAttribute('muted');
        if (!video.volume) video.volume = 1;
      }
      syncMuteUi(root, video.muted);
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var nextMuted = !video.muted;
        setMuted(nextMuted);
        // Unmute is a user gesture — keep playback going when allowed.
        if (!nextMuted) {
          userPaused = false;
          inView = true;
          safePlay(video);
        }
      });
    }

    video.addEventListener('play', function () {
      syncPlayUi(root, true);
    });
    video.addEventListener('pause', function () {
      syncPlayUi(root, false);
    });
    video.addEventListener('volumechange', function () {
      syncMuteUi(root, video.muted || video.volume === 0);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseVideo();
      } else if (!userPaused && wantAutoplay && !REDUCE) {
        tryPlay();
      }
    });

    if (!wantAutoplay || REDUCE) {
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      inView = true;
      tryPlay();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting && entry.intersectionRatio >= 0.45;
          if (inView) tryPlay();
          else pauseVideo();
        });
      },
      { threshold: [0, 0.45, 0.75] }
    );
    io.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-lp-creator-ad]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    e.target.querySelectorAll('[data-lp-creator-ad]').forEach(initRoot);
    if (e.target.matches && e.target.matches('[data-lp-creator-ad]')) initRoot(e.target);
  });
})();
